import React from 'react';
import { MessageResp, MessageRespAction } from './MessageResp';
import { NewDialog, NewMessageAction } from '..';
import { SetState } from '../../../../types';

type Props = {
	isNewAction: boolean;
	actionName: string;
	isOpen: boolean;
	dialog: NewDialog;
	updateDialogByKey: (key: keyof NewDialog, value: any) => void;
	newAction: NewMessageAction;
	setNewAction: SetState<NewMessageAction>;
};

export function MessageRespWrapper(props: Props) {
	const {
		isNewAction,
		actionName,
		isOpen,
		dialog,
		updateDialogByKey,
		newAction,
		setNewAction,
	} = props;

	if (!isOpen) {
		return null;
	}

	function updateDialog(
		key: 'suggestions' | 'isRandom' | 'messages',
		value: any,
	) {
		if (actionName) {
			updateDialogByKey('actions', {
				...dialog.actions,
				[actionName]: {
					...dialog.actions[actionName],
					[key]: value,
				},
			});
		} else {
			updateDialogByKey(key, value);
		}
	}

	function triggerDialog(action: MessageRespAction) {
	 const sourceData: any = actionName ? dialog.actions[actionName] : dialog
		if (action.op === 'toggle') {
		  updateDialog('isRandom', action.payload);
		}
		if (action.op === 'add') {
			if (action.field === "suggestions") {
				const isSuggest=action.field in sourceData
				if (!isSuggest) {
					sourceData[action.field]=[]
				}
			}
			updateDialog(action.field, [
				action.payload,
				...sourceData[action.field as 'messages' | 'suggestions'],				
			]);
		}
		if (action.op === 'edit') {
			updateDialog(
				'suggestions',
				sourceData.suggestions.map((el: any, i: number) =>
					i === action.payload.index ? action.payload.value : el,
				),
			);
		}	
		if (action.op === 'delete') {
			const values = sourceData[action.field as 'messages' | 'suggestions'].filter(
				(_el: any, i: number) => i !== action.payload,
			);
			updateDialog(action.field, values);
		}
	}


	function triggerNewAction(action: MessageRespAction) {
		if (action.op === 'toggle') {
			setNewAction((prev) => ({ ...prev, isRandom: action.payload }));
		}
		if (action.op === 'add') {
			setNewAction((prev) => ({
				...prev,
				[action.field]: [
					...(prev[action.field as 'messages' | 'suggestions'] as any),
					action.payload,
				],
			}));
		}
		if (action.op === 'edit') {
			setNewAction((prev) => ({
				...prev,
				suggestions: prev.suggestions?.map((el, i) =>
					i === action.payload.index ? action.payload.value : el,
				),
			}));
		}
		if (action.op === 'delete') {
			const values = newAction[
				action.field as 'messages' | 'suggestions'
			]?.filter((_el, i) => action.payload !== i);
			setNewAction((prev) => ({
				...prev,
				[action.field]: values,
			}));
		}
	}

	const trigger = isNewAction
		? triggerNewAction
		: triggerDialog;
	const restProps: any = isNewAction
		? newAction
		: actionName
		? dialog.actions[actionName]
		: dialog;

	return <MessageResp trigger={trigger} {...restProps} />;
}
